export interface ICourseListItem {
    id: number;
    children: ICourseListItem[]; // 子课程
    vcourseId: number; // v的课程ID
    vcourseType: number; // v的课程类型
    saasCourseId: number;
    saasCourseType: number; // saas课程类型
    name: string; // 课程名字
    leftDays: number; // 剩余天数
    projectId: number; // 项目id
    projectName: string; // 项目名称
    subjectId: number; // 科目
    subjectName: string; // 科目名称
    relationCourse: number; // 关联的子课程
    currentStudySubject: string; // 学习位置的资源名
    currentStudyUrl: string; // 继续学习地址
    currentStudyResourceId: number; // 继续学习的资源ID
    currentStudyResourceMark: string; // 继续学习的资源标识
    isAuditionCourse: number; // 是否试听
    sort: number; // 排序值
    courseNotice: {
        noticeEndTime: string;
        noticeStartTime: string;
        noticeLink: string;
        noticeTitle: string;
        noticeDesc: string;
    }; // 课程公告
    isBig: boolean; // 是否大包课
    lastLeaningTime: number; // 最新学习时间的时间戳
    otherPartnerMark: string; // 三方标识
    learnStatus: number; // 学习状态
    learnStatusDesc: string; // 学习状态说明
    courseStartTime: string; // 课程开始时间
    courseExpireTime: string; // 课程有效截至时间
    wareStatus: string; // 课程制作状态 0:完成，1:更新中，2:即将更新
    lives: ITodayLiveListItem[] | null;
}

export interface ITodayLiveListItem {
    id: number;
    courseId: number;
    gradationId: number;
    syllabusId: number;
    name: string;
    state: string;
    mode: string;
    systemTime: string;
    earlyStartTime: string;
    startTime: string;
    endTime: string;
    showRecord: boolean;
    enableSimplifyRecord: boolean;
    showSimplifyRecord: boolean;
    simplifyRecordUrl: string;
    ccLiveUrl: string;
    ccLiveH5Url: string;
    liveAppUrl: string;
    liveAppRecordUrl: string;
    recordUrl: string;
    ccLiveH5RecordUrl: string;
    ccLiveRecordingUrl: string;
    resourceId: number;
    playbackType: number;
    partnerId: number;
    useType: number;
    resourceStatus: number;
}

export interface IVCourseResult {
    courseList: { [projectId: number]: ICourseListItem[] };
    projectList: {
        id: number;
        name: string;
    }[];
    todayLive: {
        courseGroup: { [courseId: number]: ITodayLiveListItem[] };
        nowLive: number; // 直播状态 0 没有直播， 1今天有直播2 有直播进行中
    };
    learnResourceIds: number[];
}

export interface IStudyToolResult {
    slideShows: {
        bannerId: number; // banner 轮播区id
        bannerName: string; // banner 轮播区id
        picSrc: string; // 图片链接
        jumpLink: string; // 跳转链接
    }[];
    learningTools: {
        toolId: number; // 学习工具id
        iconSrc: string; // 工具icon
        iconName: string; // 学习工具名称
        jumpLink: string; // 跳转链接
    }[];
    notice: {
        noticeId: string; // 公告id
        noticeTitle: string; // 公告主题
        noticeDesc: string; // 公告文案
        jumpLink: string; // 跳转链接
    } | null;
}

export interface CanlendarLiveData {
    id: number;
    courseId: number;
    gradationId: number;
    syllabusId: number;
    name: string;
    state: string;
    mode: number;
    goPlayNum: number;
    systemTime: string;
    earlyStartTime: string;
    earlyEndTime: string;
    lateEndTime: string;
    startTime: string;
    endTime: string;
    teacherName: string;
    teacherId: number;
    showRecord: boolean;
    enableSimplifyRecord: boolean;
    showSimplifyRecord: boolean;
    simplifyRecordUrl: string;
    ccLiveUrl: string;
    ccLiveH5Url: string;
    liveAppUrl: string;
    liveAppRecordUIrl: string;
    recordUrl: string;
    ccLiveH5RecordUrl: string;
    ccLiveRecordingUrl: string;
    projectId: number;
    projectName: string;
    subjectId: number;
    resourceId: number;
    playbackType: number;
    roomId: number;
    partnerId: number;
    useType: number;
    showRecordButton: boolean;
    channel: string;
    glive: {
        class_id: number;
        meeting_id: number;
        title: string;
        vid: string;
    };
    resourceStatus: number;
}

export interface CalendarTaskListItem {
    resourceType: 'live_new' | 'smart_school' | 'personal_training';
    sort: string;
    liveDto: {
        id: number; // id
        name: string; // 名称
        systemTime: string; // 系统时间
        earlyStartTime: string; // 最早开始时间
        earlyEndTime: string; // 最早结束时间
        lateEndTime: string; // 最晚结束时间
        startTime: string; // 开始时间
        endTime: string; // 结束时间
        teacherName: string; // 老师名称
        showRecord: boolean; // 是否显示回放
        enableSimplifyRecord: boolean; // 是否启用剪辑版录制
        showSimplifyRecord: boolean; // 是否显示精简回放
        simplifyRecordUrl: string; // 精简版回放地址
        ccLiveUrl: string; // 直播web链接
        ccLiveH5Url: string; // 直播H5链接
        recordUrl: string; // 即时版回放地址--原始地址
        ccLiveH5RecordUrl: string; // 直播H5回放链接
        ccLiveRecordingUrl: string; // 直播回放链接
        projectId: number; // 项目id
        projectName: string; // 项目名称
        showRecordButton: boolean; // 是否显示回放按钮
        channel: 'gLive' | 'hermes'; // 聚合查询的渠道，gLive 、hermes
        resourceStatus: number; // 直播上课状态：最后一层条目上resource里面的status 1：未开始 2：进行中 3: 精剪回放 4：即时回放 5：暂无回放
        courseId: number; // 课程ID
        syllasbusId: number; // 大纲ID
        gradationId: number; // 阶段ID
        liveAppUrl: string; // app观看地址
        liveAppRecordUrl: string; // app及时回放地址
        // 备注：当channel=glive才有
        glive: {
            classId: number; // 班级id
            meetingId: number;
            title: string;
            vid: string;
        };
        csItemId: null;
        partnerId: number;
        playbackType: number;
        resourceId: number;
        roomId: number;
        subjectId: number;
        syllabusId: number;
        teacherId: number;
        useType: number;
    };
    smartSchoolDto: {
        id: number;
        resourcePackageId: number;
        resourceId: number;
        startTime: string;
        duration: number;
        scheduleId: number;
        category: number;
        lessonAttributes: number;
        discriminator: 'smart_school'; // 资源类型
        signStatus: number; // 签到状态:0未签到 1 是已签到  2是请假
        resource: {
            liveUrlPlayBackPc: string;
            creator: {
                id: number;
                username: string;
            };
            resourceId: number;
            durationSeconds: number;
            tagId: number;
            isDelete: string;
            description: string;
            bindLiveId: number;
            title: string;
            uri: string;
            discriminator: string;
            duration: number;
            createdAt: string;
            durationMinutes: number;
            playbackLink: string;
            playbackMode: number;
            startTime: string;
            endTime: string;
            partnerId: number;
            id: number;
            tag: string;
            live: string;
            updatedAt: string;
        };
        courseId: number;
    };
    personalTrainingDto: {
        id: number; // 私教预约id
        serviceTeamId: number; // 团队id
        serviceTeamName: string; // 团队名称
        startTime: string; // 开始时间
        endTime: string; // 结束时间
        earlyStartTime: string; // 直播可以提前开始的时间
        teacherId: number; // 老师id
        teacherName: string; // 老师名称
        isEnterStudio: number; // 状态 0-可以进入 / 1-未开始 / 2-迟到 / 3-已结束
        enterStudioPath: string; // 直播地址
        isPlayback: string; // 是否有回放
        enterPlaybackPath: string; // 回放地址
        projectId: number; // 项目id
        subjectId: number; // 科目id
        subjectName: string; // 科目名称
        serviceType: number; // 上课方式 （100529222 直播 100529221 电话 100529223 面授）
        isWatching: string;
        sort: string;
    };
}

export interface ICalendarData {
    calendarList: string[]; // 有任务的日期
    liveSmartPersonalTaskList: CalendarTaskListItem[];
}

export interface ExamResponse {
    diagnoseStatus: number;
    examDate: ExamDateItem[];
}

export interface ExamDateItem {
    createdAt: string;
    examDate: string;
    id: number;
    isPassed: number;
    leftDays: string;
    projectId: number;
    projectName: string;
    studentId: number;
    subjectId: number;
    subjectName: string;
    updatedAt: null;
}

// 直播状态 直播上课状态： 1：未开始 2：进行中 3: 精剪回放 4：即时回放 5：暂无回放 6：教室已开启  playBackType：2 直播回放班直播只允许等有链接看回放
export enum LiveStatus {
    notStart = 1,
    live = 2,
    clipPlayback = 3,
    onlinePlayback = 4,
    notPlayback = 5,
    preLive = 6,
    playBackType = 2,
}

// 0-待学习；1-学习中；2-已学习；3-已到期
export enum LearnStatus {
    READY_FOR_STUDY = 0,
    STUDYING = 1,
    STUDYED = 2,
    STUDY_DONE = 3,
}

export enum WareStatus {
    COURSE_DONE = '0',
    COURSE_UPDATE = '1',
    COURSE_UPCOMING_UPDATE = '2',
}

export enum SaasCourseType {
    NORMAL2 = 10,
    EP3 = 13,
    GLIVE2 = 16,
    EP_LUCA = 18,
}

export enum personalTrainingStatus {
    ENTER = 0,
    NOT_START = 1,
    BE_LATE = 2,
    PLAYBACK = 3,
}

// 面授签到状态：0.未处理 1.已签,2.请假
export enum SmartSchoolSignStatus {
    notStart = 0,
    sign = 1,
    leave = 2,
}

export interface IStudentInfo {
    studentId: number;
    days: number;
    headImgUrl: string;
    nickName: string;
    itemDone: number;
}

export interface IResourcesCoverListItem {
    cover: string;
    discriminator: string;
    resourceId: number;
}
